module.exports = __webpack_public_path__ + "img/desktop-map-MF-EN.c7d56618.svg";